var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container--pkmn"},[_c('v-row',[_c('v-col',[_c('top-nav')],1)],1),_c('v-row',{staticClass:"page page--anonymous"},[_c('v-col',{staticClass:"anonymous__section anonymous__section--content text-left"},[(_vm.isMaintenance)?_c('div',{staticClass:"maintenance-overlay"}):_vm._e(),_vm._t("content")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }